import * as React from 'react';
import ReactModal from 'react-modal';

type ModalStyles = ReactModal.Styles;

interface Props extends ReactModal.Props {
  style?: ModalStyles;
  isCalendly?: boolean;
}

export const Modal: React.FunctionComponent<Props> = ({
  children,
  style,
  ...props
}) => {
  let contentStyle: ModalStyles['content'] = {};
  let overlayStyle: ModalStyles['overlay'] = {};

  if (style) {
    contentStyle = style.content || {};
    overlayStyle = style.overlay || {};
  }

  return (
    <ReactModal
      {...props}
      style={{
        content: {
          border: 'none',
          bottom: 'auto',
          left: 'auto',
          maxWidth: '720px',
          minWidth: '584px',
          right: 'auto',
          top: 'auto',
          ...contentStyle,
        },
        overlay: {
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          zIndex: 1,
          ...overlayStyle,
        },
      }}
    >
      {children}
    </ReactModal>
  );
};

if (typeof document !== 'undefined') {
  ReactModal.setAppElement('body');
}

Modal.displayName = 'Modal';

export default Modal;
export type { Props as ModalProps } from 'react-modal';
